import { Injectable } from '@angular/core';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class MileStonesBoundsService {
  noShowIntervals = [];
  calledEmployeeIntervals = [];
  actualSignInLocations = [];
  actualSignOutLocations = [];
  minimum = 0;
  maximum = 0;
  intervalValue = 10000;

  constructor(private commonService: CommonService) {}

  private filterValidTimes(times: number[]): number[] {
    return times.filter(time => time !== 0);
  }

  getLowerBound() {
    this.noShowIntervals = this.filterValidTimes(this.commonService.noShowDriverActions?.map(noShow => noShow.markedAt) || []);
    this.calledEmployeeIntervals = this.filterValidTimes(this.commonService.callEmployeeDriverActions?.map(calledEmployee => calledEmployee.callStartTime) || []);
    this.actualSignInLocations = this.filterValidTimes(this.commonService.tripDetailsRes.getValue()['tripDetails']['employees']?.map(employee => employee.actualPickupTime) || []);
    // this.actualSignOutLocations = this.filterValidTimes(this.commonService.tripDetailsRes.getValue()['tripDetails']['employees']?.map(employee => employee.actualDropTime) || []);

    // Calculate the minimum time across all intervals
    this.minimum = Math.min(
      ...this.noShowIntervals,
      ...this.calledEmployeeIntervals,
      ...this.actualSignInLocations,
      this.commonService.tripTimings.actualStartTime,
      // ...this.actualSignOutLocations
    );

    this.unshiftStartMileStones(this.commonService.locationListRes.getValue());
  }

  getUpperBound() {
    this.noShowIntervals = this.filterValidTimes(this.commonService.noShowDriverActions?.map(noShow => noShow.markedAt) || []);
    this.calledEmployeeIntervals = this.filterValidTimes(this.commonService.callEmployeeDriverActions?.map(calledEmployee => calledEmployee.callStartTime) || []);
    this.actualSignOutLocations = this.filterValidTimes(this.commonService.tripDetailsRes.getValue()['tripDetails']['employees']?.map(employee => employee.actualDropTime) || []);

    this.maximum = Math.max(
      ...this.noShowIntervals,
      ...this.calledEmployeeIntervals,
      ...this.actualSignOutLocations,
      this.commonService.tripTimings.actualEndTime,
    );

    this.pushEndMileStones(this.commonService.locationListRes.getValue());

  }

  private unshiftStartMileStones(mileStones: any[]) {

    console.log(
      'milestones before unshift',
      mileStones.length
    )
    const timeDifference = this.commonService.tripTimings.plannedStartTime - this.minimum;
    const startTimeDifferenceInSeconds = timeDifference / 1000;
    this.commonService.outOfRangeLowerBound = Math.abs(Math.floor(startTimeDifferenceInSeconds));
    let currentTimestamp = this.commonService.tripTimings.actualStartTime;

    const startMilestones = this.generateMilestones(currentTimestamp, startTimeDifferenceInSeconds, false);
    mileStones.unshift(...startMilestones);
    this.commonService.locationListRes.next(mileStones);
    console.log(
      'milestones before unshift',
      mileStones.length
    )

  }

  private pushEndMileStones(mileStones: any[]) {
    const timeDifference =  this.commonService.tripTimings.plannedEndTime - this.commonService.tripTimings.actualEndTime;
    const endTimeDifferenceInSeconds = timeDifference / 1000;

    let currentTimestamp = this.commonService.tripTimings.actualEndTime;
    this.commonService.outOfRangeUpperBound = Math.abs(Math.floor(endTimeDifferenceInSeconds));

    const endMilestones = this.generateMilestones(currentTimestamp, endTimeDifferenceInSeconds, true);
    mileStones.push(...endMilestones);

  }

  private generateMilestones(currentTimestamp: number, timeDifferenceInSeconds: number, increment: boolean) {
    let currentTimestamps = currentTimestamp
    const milestones = [];
    for (let i = 0; i < Math.abs(Math.floor(timeDifferenceInSeconds)); i++) {
      if(increment) {
        currentTimestamps += this.intervalValue; // Adjust by 1 second each time
      }
      else {
        currentTimestamps -= this.intervalValue; // Adjust by 1 second each time
      }
      const milestone = {
        latitude: 12.917883,
        longitude: 77.638256,
        mBearing: 2.729908,
        mSpeed: 21.594118,
        mStep: 21.743597,
        mAccuracy: 9,
        timeStamp: new Date(currentTimestamps).toLocaleString(), // Optional formatted timestamp
        time: currentTimestamps,
        type: 1
      };
      milestones.push(milestone);
    }
    return increment ? milestones : milestones.reverse();
  }
}
